export default "__VITE_ASSET__EIy18qMA__"